<template>
  <a-form-model
    :model="form"
    ref="eventForm"
    :rules="rules"
    :label-col="{ span: 4 }"
    :wrapper-col="{ span: 20 }"
  >
    <a-form-model-item label="父菜单" prop="parentId">
      <a-tree-select
        v-model="form.parentId"
        style="width: 100%"
        :replaceFields="{ title: 'menuName', value: 'menuId', children: 'children' }"
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        :tree-data="treeData"
        placeholder="请选择父菜单"
        tree-default-expand-all
      >
      </a-tree-select>
    </a-form-model-item>
    <a-form-model-item label="菜单名字" prop="menuName">
      <a-input v-model="form.menuName" placeholder="请输入菜单名字" />
    </a-form-model-item>
    <a-form-model-item label="菜单类型" prop="type">
      <a-radio-group v-model="form.type">
        <a-radio value="dir"> 目录 </a-radio>
        <a-radio value="menu"> 菜单 </a-radio>
        <a-radio value="btn"> 按钮 </a-radio>
      </a-radio-group>
    </a-form-model-item>

    <a-form-model-item label="路径" prop="path" v-if="form.type != 'btn'">
      <a-input v-model="form.path" placeholder="请输入路径" />
    </a-form-model-item>

    <a-form-model-item label="组件地址" prop="componentPath" v-if="form.type != 'btn'">
      <a-input v-model="form.componentPath" placeholder="请输入组件地址" />
    </a-form-model-item>

    <a-form-model-item label="权限标志" prop="sign" v-if="form.type != 'dir'">
      <a-input v-model="form.sign" placeholder="请输入权限标志" />
    </a-form-model-item>

    <a-form-model-item label="图标名称" prop="icon" v-if="form.type != 'btn'">
      <a-input v-model="form.icon" placeholder="请输入图标名称" />
    </a-form-model-item>

    <a-form-model-item label="菜单状态" prop="status" v-if="form.type == 'menu'">
      <a-radio-group v-model="form.status">
        <a-radio :value="1"> 启用 </a-radio>
        <a-radio :value="-1"> 停用 </a-radio>
      </a-radio-group>
    </a-form-model-item>

    <a-form-model-item label="是否隐藏" prop="isHide">
      <a-radio-group v-model="form.isHide">
        <a-radio :value="-1"> 显示 </a-radio>
        <a-radio :value="1"> 隐藏 </a-radio>
      </a-radio-group>
    </a-form-model-item>

    <a-form-model-item label="排序值" prop="orderNum" v-if="form.type != 'btn'">
      <a-input-number style="width: 100%" v-model="form.orderNum" placeholder="请输入排序值" />
    </a-form-model-item>

    <a-form-model-item :wrapper-col="{ span: 20, offset: 4 }">
      <a-button type="primary" @click="onSubmit">
        {{ formModel ? '修 改' : '创 建' }}
      </a-button>
      <a-button style="margin-left: 10px" @click="resetForm"> 重 置 </a-button>
    </a-form-model-item>
  </a-form-model>
</template>
<script>
import { createMenuApi, updateMenuApi } from '@/api/System/Menu'
export default {
  data() {
    return {
      form: {
        menuId: '',
        parentId: -1,
        menuName: '',
        path: '',
        sign: '',
        status: 1,
        type: 'dir',
        componentPath: '',
        orderNum: 1,
        isHide: -1,
        isCache: -1,
        icon: ''
      },
      rules: {
        parentId: [{ required: true, message: '父菜单必填', trigger: ['change', 'blur'] }],
        menuName: [{ required: true, message: '菜单名称必填', trigger: ['change', 'blur'] }]
      },
      treeData: []
    }
  },

  props: ['formModel', 'treeList'],
  created() {
    if (this.formModel) {
      this.form = { ...this.formModel }
    }
    this.treeData = [
      {
        menuId: -1,
        key: -1,
        menuName: '根节点',
        children: [...this.treeList]
      }
    ]
  },

  methods: {
    //生产表单数据
    getPostData() {
      let postData = { ...this.form }
      return postData
    },

    //修改菜单
    async updateMenu() {
      const res = await updateMenuApi({ ...this.getPostData() })
      const { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.$emit('refresh')
      } else {
        this.$message.error(msg)
      }
    },

    //添加菜单
    async createMenu() {
      const res = await createMenuApi({ ...this.getPostData() })
      const { code, msg } = res
      if (code == '200') {
        this.$message.success(msg)
        this.$emit('refresh')
      } else {
        this.$message.error(msg)
      }
    },

    resetForm() {
      this.$refs.eventForm.resetFields()
    },

    onSubmit() {
      this.$refs.eventForm.validate(async (valid) => {
        if (valid) {
          if (this.formModel) {
            this.updateMenu()
          } else {
            this.createMenu()
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped></style>
